import dayjs from 'dayjs';
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CookieKey } from "../../../../../enums/CookieKey";
import { CookiesHelper } from "../../../../../helpers/CookiesHelper";
import { useEffectSuccess } from "../../../../Providers/helpers/useCompare";
import { isDebugIdleModal } from '../../constants';

const selectorFn = state => ({
    reauthenticateState: state.Auth.reauthenticateState,
    loginState: state.Auth.loginState,
    lastApiCallTime: state.Logger.lastApiCallTime,
    isSessionLockEnabled: state.User.user?.session_idle_lock,
});

/**
 * This function will listen to reauthenticateState and loginState to reset cookie
 * @param {*} resetCookieAndCloseModal
 */
export const useResetCookieListener = resetCookieAndCloseModal => {
    const dispatch = useDispatch();
    const {
        reauthenticateState,
        loginState,
        lastApiCallTime,
        isSessionLockEnabled,
    } = useSelector(selectorFn, shallowEqual);

    // Close modal when reauthenticate success (idle modal), remove cookie
    useEffectSuccess(reauthenticateState, () => {
        if (isDebugIdleModal)
            console.log('aaa debug InactiveModalV2 - useEffectresetCookieListener - set cookie', {reauthenticateState});
        resetCookieAndCloseModal();
    }, [resetCookieAndCloseModal]);

    // Close modal when login success (expired modal), remove cookie
    useEffectSuccess(loginState, () => {
        if (isDebugIdleModal)
            console.log('aaa debug InactiveModalV2 - useEffectresetCookieListener - set cookie');
        resetCookieAndCloseModal();
    }, [resetCookieAndCloseModal]);

    useEffect(() => {
        // check difference between lastApiCallTime and current time
        const idleTimeoutTime = CookiesHelper.getCookie(CookieKey.session_idle);
        const diff = dayjs(idleTimeoutTime).diff(dayjs(), 'second');
        const isIdle = diff <= 0;

        // set cookie if initialState (no cookie) or not yet idle (do not set if already idle)
        if (isSessionLockEnabled && (!idleTimeoutTime || !isIdle)) {
            if (isDebugIdleModal) {
                console.log('aaa debug InactiveModalV2 - useEffectresetCookieListener - set cookie', {
                    idleTimeoutTime,
                    isIdle,
                    isSessionLockEnabled,
                });
            }
            resetCookieAndCloseModal();
        }
    }, [dispatch, isSessionLockEnabled, lastApiCallTime, resetCookieAndCloseModal]);
};
